import {
  EVALUATION_KIND_SELECT,
  INIT_FAIL,
  INIT_SUCCESS,
  SEARCH_FAIL,
  SEARCH_SUCCESS
} from "../actions/evaluationImplement";

const initialState = {
  rows: [],
  evaluationList: [],
  evaluationTerms: [],
  listId: null,
  termId: null,
  evaluationKind: null
};

const evaluationImplement = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case INIT_SUCCESS:
      return {
        ...state,
        evaluationList: payload.evaluationList,
        evaluationTerms: payload.evaluationTerms
      };
    case INIT_FAIL:
      return {
        ...state,
        error: payload.error
      };
    case SEARCH_SUCCESS:
      return {
        ...state,
        listId: payload.listId,
        termId: payload.termId,
        rows: payload.rows
      };
    case SEARCH_FAIL:
      return {
        ...state,
        error: payload.error
      };
    case EVALUATION_KIND_SELECT:
      return {
        ...state,
        evaluationKind: payload.evaluationKind
      };
    default:
      return {
        ...state
      };
  }
};

export default evaluationImplement;
